import type { PropsWithChildren } from 'react'

interface Props {
  title?: string
  severity?: 'info' | 'success' | 'error' | 'warning'
  visible?: boolean
  className?: string
  texts?: {
    closeButton: string
  }
  autoClose?: boolean
  reusable?: boolean
  onClose?: () => void
  autoCloseTimeout?: number
}

export type SnackbarProps = PropsWithChildren<Props>

export const SnackbarDefaultValues: Partial<SnackbarProps> = {
  severity: 'info',
  visible: false,
  autoClose: true,
  reusable: false,
  autoCloseTimeout: 5 * 1000,
}
